import angular from 'angular';
import gridHeight from "../core/shared-service/grid-utils";

class communityStockSoftware {
    /*  @ngInject */


    constructor($state, logger, CommunitySvc, AuthSvc, $scope,$window, $translate, uiGridExporterService, $stateParams) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.CommunitySvc = CommunitySvc;
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.uiGridExporterService = uiGridExporterService;
        this.$stateParams = $stateParams;
    }

    $onInit() {
        this.modeMail = null;
        this.modeWebService = null;
        this.containerPromise = this.CommunitySvc.getAllStockSoftware();
        this.containerPromise.then(
            data => {
                this.gridOptions.data = data;
                Object.keys(data).forEach(key => {
                        if (data[key] != null) {
                            if (data[key].modeMail === true && data[key].modeWebService === true) {
                                data[key].transmissionMode = "Mail et Web service"
                            } else if (data[key].modeMail === true) {
                                data[key].transmissionMode = "Mail"
                            } else if (data[key].modeWebService === true) {
                                data[key].transmissionMode = "Web service"
                            }
                        }
                    })

                Object.keys(data).map(key => {
                    if(!isNaN(parseInt(key)))
                    return data[key].deleted === true ? data[key].deleted = "non" : data[key].deleted = "oui"
                })
            },
            () => {}
        );

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="community.details.stock-software-update({ id : row.entity.id })">' +
            '<div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'name',
                    displayName: 'Nom logiciel',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
                {
                    name: 'editorName',
                    displayName: 'Nom éditeur',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
                {
                    name: 'transmissionMode',
                    displayName: "Mode d'utilisation",
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
                {
                    name: 'deleted',
                    displayName: 'Disponible',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'defaultcursor',
                },
            ],
            paginationPageSizes: [10, 30, 50],
            paginationPageSize: 10,
            exporterOlderExcelCompatibility: true,
            useExternalPagination: false,
            useExternalSorting: true,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }
    newStockSofware(){
        this.$state.go('community.details.stock-software-create')
    }

    back(){
        this.$state.go('community.list.main');
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

}

angular.module('app.community').component('communityStockSoftware', {
    templateUrl: require('./community-stock-software.html'),
    controller: communityStockSoftware,
    bindings: {
        initMenuConsult: '<',
        community: '<',
    },
});
